export default "__VITE_ASSET__Brn50b8u__"